import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import Client from './client';

export const useOtpRequest = (
  options: Omit<
    UseMutationOptions<
      Awaited<ReturnType<typeof Client.requestOtp>>,
      Error,
      Parameters<typeof Client.requestOtp>[0],
      unknown
    >,
    'mutationFn'
  > = {},
) => {
  const { mutateAsync, status } = useMutation({
    mutationFn: Client.requestOtp,
    ...options,
  });

  return {
    requestOtpMutateAsync: mutateAsync,
    requestOtpStatus: status,
  };
};
